module.exports = __webpack_public_path__ + "img/product-peregrine-u8-rgb.b6b9e525.png";